import React from "react";
import {
  Flex,
  Box,
  Text,
  IconButton,
  Button,
  Divider,
  Card,
  CardBody,
  Avatar,
  Link,
  useMediaQuery,
} from "@chakra-ui/react";
import Lottie from "lottie-react";
import Navbar from "../components/nav/index";
import RelevicIcon from "../assets/icons/relevic.jpeg";
import SimplifyVmsIcon from "../assets/icons/simplify.jpeg";
import AWSIcon from "../assets/icons/aws.jpeg";
import Yale from "../assets/icons/yale.jpeg";
import CV from "../assets/files/CV.pdf";
import responsiveAnimation from "../assets/animations/newSecond.json";
import downloadIconAnimation from "../assets/animations/downloadIcon.json";
import linkedIconAnimation from "../assets/animations/linkedIn.json";
import githubIconAnimation from "../assets/animations/github.json";

import "./styles.css";

const workExperience = [
  {
    companyImage: SimplifyVmsIcon,
    companyName: "Simplify VMS",
    link: "https://www.simplifyvms.com/",
    specialization: "Associate Software Engineer",
    duration: "2023 - 2024",
  },
  {
    companyImage: RelevicIcon,
    companyName: "Relevic",
    link: "https://www.relevic.com/",
    specialization: "Software Engineer",
    duration: "2024 - Present",
  },
];

const certifications = [
  {
    companyImage: AWSIcon,
    companyName: "Amazon Web Services (AWS)",
    link: "https://www.coursera.org/account/accomplishments/certificate/RADDA7K62W76",
    specialization: "AWS Cloud Technical Essentials",
    duration: "July 2023",
  },
  {
    companyImage: Yale,
    companyName: "Yale University",
    link: "https://www.coursera.org/account/accomplishments/verify/PY68MEHVEKE9?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course",
    specialization: "Managing Emotions",
    duration: "September 2023",
  },
];

const Home = () => {
  const [isLargerThanTabSize] = useMediaQuery("(min-width: 992px)");
  const [isLargerThanMobileSize] = useMediaQuery("(min-width: 768px)");
  const [iconHover, setIconHover] = React.useState({
    downloadIcon: false,
    linkedInIcon: false,
    githubIcon: false,
  });

  const handleIconHover = (iconName, value) => {
    setIconHover({
      ...iconHover,
      [iconName]: value,
    });
  };
  const downloadPDF = () => {
    const link = document.createElement("a");
    link.href = CV; // Path to your image
    link.download = "Moiz_Nafey.pdf"; // Name of the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box backgroundColor={"#000000"} gap={20} minHeight={"100vh"}>
      <Flex direction={"column"}>
        <Navbar />

        <Flex
          direction={isLargerThanMobileSize ? "row" : "column"}
          justifyContent={"space-between"}
          alignItems={isLargerThanMobileSize ? "" : "center"}
          color={"gray.300"}
          marginX={{ base: 5, lg: 10, xl: 20 }}
        >
          <Flex
            marginX={10}
            gap={20}
            direction={"column"}
            width={isLargerThanTabSize ? "50%" : "100%"}
            justifyContent={"flex-start"}
            alignItems={isLargerThanTabSize ? "flex-start" : "center"}
            marginTop={"100px"}
          >
            <Flex
              width={"100%"}
              justifyContent={isLargerThanTabSize ? "flex-start" : "center"}
            >
              <Box boxSize={{ base: "300px", "2xl": "500px" }}>
                <Lottie
                  cellPadding={0}
                  animationData={responsiveAnimation}
                  loop={true}
                  autoplay={true}
                  style={{ width: "100%", height: "100%" }}
                  rendererSettings={{
                    preserveAspectRatio: "xMidYMid slice",
                  }}
                />
              </Box>
            </Flex>
            <Flex direction={"column"}>
              <Text fontSize={"5xl"} textAlign={{ base: "center", lg: "left" }}>
                I'm Moiz Nafey
              </Text>
              <Text textAlign={{ base: "center", lg: "left" }}>
                Software Engineer based in Lahore, Pakistan
              </Text>
            </Flex>
          </Flex>

          <Flex
            direction={"column"}
            margin={10}
            gap={10}
            width={isLargerThanTabSize ? "50%" : "100%"}
            alignItems={isLargerThanTabSize ? "flex-start" : "center"}
          >
            <Text fontSize={"3xl"} textAlign={{ base: "center", lg: "left" }}>
              Passionate creating great products for my clients
            </Text>
            <Flex
              gap={5}
              direction={isLargerThanMobileSize ? "row" : "column"}
              alignItems={isLargerThanMobileSize ? "" : "center"}
            >
              <Button
                onMouseEnter={() => handleIconHover("downloadIcon", true)}
                onMouseLeave={() => handleIconHover("downloadIcon", false)}
                backgroundColor={"#34A9A7"}
                color={"white"}
                paddingX={5}
                paddingY={3}
                rightIcon={
                  <Box width={"20px"} height={"40px"}>
                    <Lottie
                      cellPadding={10}
                      animationData={downloadIconAnimation}
                      loop={iconHover.downloadIcon}
                      autoplay={iconHover.downloadIcon}
                      style={{ width: "20px", height: "30px" }}
                      rendererSettings={{
                        preserveAspectRatio: "xMidYMid slice",
                      }}
                    />
                  </Box>
                }
                _hover={{ background: "", transform: "scale(1.05)" }}
                animation={"ease-in-out"}
                onClick={downloadPDF}
              >
                Download CV
              </Button>
              <Flex gap={2}>
                <IconButton
                  onMouseEnter={() => handleIconHover("linkedInIcon", true)}
                  onMouseLeave={() => handleIconHover("linkedInIcon", false)}
                  backgroundColor={"#34A9A7"}
                  color={"white"}
                  _hover={{ background: "", transform: "scale(1.05)" }}
                  animation={"ease-in-out"}
                  fontSize={"xl"}
                  icon={
                    <Lottie
                      cellPadding={10}
                      animationData={linkedIconAnimation}
                      loop={iconHover.linkedInIcon}
                      autoplay={iconHover.linkedInIcon}
                      style={{ width: "50px", height: "100px" }}
                      rendererSettings={{
                        preserveAspectRatio: "xMidYMid slice",
                      }}
                    />
                  }
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/moiz-nafey/",
                      "_blank"
                    )
                  }
                />
                <IconButton
                  onMouseEnter={() => handleIconHover("githubIcon", true)}
                  onMouseLeave={() => handleIconHover("githubIcon", false)}
                  backgroundColor={"#34A9A7"}
                  color={"white"}
                  _hover={{ background: "", transform: "scale(1.05)" }}
                  animation={"ease-in-out"}
                  fontSize={"xl"}
                  icon={
                    <Lottie
                      animationData={githubIconAnimation}
                      loop={iconHover.githubIcon}
                      autoplay={iconHover.githubIcon}
                      style={{ width: "30px", height: "30px" }}
                      rendererSettings={{
                        preserveAspectRatio: "xMidYMid slice",
                      }}
                    />
                  }
                  onClick={() =>
                    window.open("https://github.com/nafey7", "_blank")
                  }
                />
              </Flex>
            </Flex>

            <Divider height={"1px"} backgroundColor={"gray.400"} />
            <ExperienceCards
              experienceList={workExperience}
              title={"Work Experience"}
            />

            <Divider height={"1px"} backgroundColor={"gray.400"} />

            <ExperienceCards
              experienceList={certifications}
              title={"Certifications"}
            />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Home;

export const ExperienceCards = ({ experienceList, title }) => {
  return (
    <Flex direction={"column"} gap={5}>
      <Text>{title}</Text>
      {experienceList.map((item, index) => {
        return (
          <Link
            href={`${item.link}`}
            isExternal
            key={index}
            _hover={{ textDecoration: "none" }}
          >
            <Card
              backgroundColor={"gray.100"}
              borderRadius={"10px"}
              width={"100%"}
              _hover={{
                transform: "scale(1.05)",
                transition: "transform 0.3s ease-in-out",
              }}
            >
              <CardBody>
                <Flex
                  alignItems={"center"}
                  gap={10}
                  justifyContent={"space-between"}
                  direction={{ base: "column", lg: "row" }}
                >
                  <Flex gap={10} justifyContent={"flex-start"} width={"100%"}>
                    <Avatar
                      name="Dan Abrahmov"
                      src={`${item.companyImage}`}
                      boxShadow={"md"}
                    />
                    <Flex direction={"column"}>
                      <Text fontSize={"sm"}>{item.specialization}</Text>
                      <Text as="b">{item.companyName}</Text>
                    </Flex>
                  </Flex>

                  <Text fontSize={"md"} whiteSpace={"nowrap"}>
                    {item.duration}
                  </Text>
                </Flex>
              </CardBody>
            </Card>
          </Link>
        );
      })}
    </Flex>
  );
};
